import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import orderBy from 'lodash/orderBy';
import { createDeleteReleaseCommand } from '../../../api/commands/factory/createReleaseCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class DeleteRelease extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'DeleteRelease';

    public constructor(public id: string, public moveCardsToId: string, public shouldSendCommand: boolean = true) {
        super(DeleteRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: DeleteRelease): Promise<boolean> => {
    if (!action.shouldSendCommand) {
        return true;
    }

    const release = state.releases.find((x) => x.id === action.id);

    return await useSendCommandAsync(action, {
        createCommand: async () => await createDeleteReleaseCommand(state.id, release.id, release.name, action.moveCardsToId),
    });
};

const reducer = (state: StorymapState, action: DeleteRelease): void => {
    orderBy(
        state.subtasks.filter((x) => x.releaseId === action.id),
        'order'
    ).forEach((x) => {
        const orders = state.subtasks.filter((s) => s.releaseId === action.moveCardsToId && s.taskId === x.taskId).map((s) => s.order);
        const nextOrder = orders.length == 0 ? 0 : Math.max(...orders) + 1;

        x.releaseId = action.moveCardsToId;
        x.order = nextOrder;
    });

    const release = state.releases.find((x) => x.id === action.id);

    state.releases.filter((x) => x.order > release.order).forEach((x) => x.order--);

    state.releases = state.releases.filter((x) => x.id !== action.id);
};

//@ts-ignore
registerMiddleware(DeleteRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeleteRelease.ACTION_TYPE, reducer);
